"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _InputField = require("./InputField");
Object.keys(_InputField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InputField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InputField[key];
    }
  });
});